/*
 * @Descripttion: 定位panel
 * @version:
 * @Author: 乔凡
 * @Date: 2021-07-19 10:17:12
 * @LastEditors: bbqin
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Icon from '../../../Icon';
import { isFunction, isWrong, isArray } from '../../utils/index';
import { formatDatetime, getMultiLang, changeTime, isNullOrVoid, formatNumber, formatAcuracy, getRandomPassword, getLangCode } from '@platform/api';
import CONFIG from '../../config';

const { ROW_STATUS } = CONFIG;

import Dnd from '../../../Dnd';
import Button from '../../../Button';
import Select from '../../../Select';
import NCFormControl from '../../../-FormControl';
import Checkbox from '../../../Checkbox';
import ButtonGroup from '../../../ButtonGroup';
import HotKeys from '../../../HotKeys';
import Tooltip from '../../../Tooltip';


require('./panel.less');

const { Option } = Select;

/**
 * 数据处理
 * @param {*} IType 
 * @param {*} display 
 * @param {*} value 
 * @param {*} scale 
 * @param {*} attrcode 
 * @param {*} languageMeta 
 * @param {*} values 
 * @param {*} datatype 
 * @param {*} options 
 * @param {*} multiple 
 * @param {*} langJson 
 */
const handleBrowse = function (IType, display, value, scale, attrcode, languageMeta, values, datatype, options, multiple, langJson, numFlag = false) {
    // TODO 数据格式的转换
    // 特殊处理下逻辑型  枚举类型
    if (
        datatype === "32" &&
        ["select", "checkbox", "radio"].includes(IType) &&
        isArray(options) &&
        !display &&
        value !== null &&
        value !== undefined
    ) {
        if (IType === "checkbox" || multiple) {
            let displayList = options
                .filter(item => value.includes(item.value))
                .map(option => {
                    return option.display;
                });
            return displayList.join(",");
        } else {
            let { display } =
                options.filter(item => item.value == value)[0] || {};
            return display;
        }
    }

    switch (true) {
        case CONFIG.displayTypes.includes(IType):
            return display || value;
        case CONFIG.boolean.includes(IType):
            return value == "Y" || value == true ? langJson["table_location_yes"] : langJson["table_location_no"];
        case CONFIG.timeTypes.includes(IType):
            if (IType === "datetimepicker") {
                return formatDatetime(changeTime(value, "YYYY-MM-DD HH:mm:ss"), 'datetime');
            } else if (IType === "timepicker") {
                return formatDatetime(value, 'time');
            } else if (IType === "datePickerNoTimeZone") {
                return formatDatetime(value, 'date');
            }
            return formatDatetime(changeTime(value), 'date');
        case IType === "label":
            return isNullOrVoid(display) ? value : display || value;
        case IType === "number":
            // 表格浏览态加了四舍五入
            if (numFlag) {
                return formatAcuracy(value, scale, true);
            }
            return formatNumber(formatAcuracy(value, scale), true);
        case IType === "password":
            // 密码框浏览态显示***
            return value && getRandomPassword();
        case IType === "residtxt": // 对多语的处理
            let LangCode = getLangCode();
            let loginLang = languageMeta.filter(i => i.languageCode == LangCode);
            if (loginLang.length > 0) {
                loginLang[0].index === "1" ? (loginLang[0].index = "") : "";
                if (
                    values[attrcode + loginLang[0].index] &&
                    values[attrcode + loginLang[0].index].value
                ) {
                    value = values[attrcode + loginLang[0].index].value;
                    return value;
                }
                return value;
            }
            return value;
        default:
            return isNullOrVoid(display) ? value : display || value;
    }
}
/**
 * 定位面板组件
 * @param {*} tableColumns  表格模版信息
 * @param {*} tableName 表格名称
 * @param {*} langJson 多语
 * @param {*} handleResetCallBack 重置后回调
 * @param {*} handleFilterCallBack 筛选后回调
 * 
 */
class locationPanel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: this.getFlatColumns(props.tableColumns),
            locationColumns: this.getLocationColumns(props.tableColumns),
            langJson: props.langJson,
            selectedValue: props.selectedAttrcode,
            selectedColumn: props.selectedColumn,
            data: props.locationData,
            rowKey: props.rowKey,
            customColData: props.customColData,
            inputValue: "",
            checkValue: false,
            locationIndexs: [], // 定位后得到的index数组
            currentIndex: -1, // 当前定位所在的位置 
        }
        this.LocationPanelRef = null;
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => { });
            }
        };
        getMultiLang({ moduleId: 'base_table', callback });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ data: nextProps.locationData });
    }
    // 卸载前删除绑定keydown
    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        document.removeEventListener('keydown', this.keyDownCallBack);
    }

    // 更新完绑定keydown
    componentDidMount() {
        document.addEventListener('keydown', this.keyDownCallBack);
    }

    // 获取所有一级表头
    getFlatColumns = (columns, nonLocationCodes = ['opr', 'blankrow']) => {
        let result = [];
        columns.map(item => {
            if (item.children) {
                result = result.concat(this.getFlatColumns(item.children));
            }
            if (!item.attrcode && item.dataIndex && !nonLocationCodes.includes(item.dataIndex)) {
                result.push(item);
            } else if (!item.children && !nonLocationCodes.includes(item.attrcode) && item.visible) {
                result.push(item);
            }
        })
        return result;
    }
    // 获取定位平铺列
    getLocationColumns = columns => {
        let nonLocationCodes = ['numberindex', 'opr', 'checkbox', 'blankrow'];
        return this.getFlatColumns(columns, nonLocationCodes);
    }

    /**
     * 每次弹开重新渲染
     * 关闭弹窗回调
     */
    handleHide = () => {
        this.setState({
            inputValue: "",
            checkValue: false,
            locationIndexs: [],
            currentIndex: -1,
        })
        this.props.renderLocationResult([], -1);
        this.props.onHide();
    };
    /**
    * 定位  通过操作选择列的dom实现
    */
    handleLocation = () => {
        // 定位数据并找到当前索引
        let { data, locationIndexs = [], rowKey, customColData, inputValue, selectedColumn, checkValue, currentIndex } = this.state;
        let { tableScope } = this.props;
        let { props } = tableScope;
        let { treeTableRef, async, getLocationTreeData, updateTreeTableData } = props;
        if (!inputValue) {
            this.setState({
                locationIndexs: [],
                currentIndex: -1,
            }, () => {
                this.getLocationResult();
            });
        } else {
            if (treeTableRef && async && this.asyncFlag) {
                // 树表异步加载数据 需要业务通过查询修改数据源，修改完成后走定位逻辑
                this.asyncFlag = false;
                let that = this;
                getLocationTreeData(selectedColumn, inputValue)
                    .then(data => {
                        updateTreeTableData(data);
                        that.handleLocation();
                    });
            } else {
                let newLocationIndexs = this.getLocationIndex(selectedColumn, data, rowKey, customColData, inputValue, checkValue, 0, "root", "", treeTableRef);
                this.setState({
                    locationIndexs: newLocationIndexs,
                    currentIndex: newLocationIndexs.length ? 0 : -1,
                }, () => {
                    this.getLocationResult();
                });
            }
        }
    };

    // 获取树表定位行的currentIndex
    getTreeTableCurrentIndex(data, newLocationIndexs, currentIndex) {
        let parentKeys = [];
        for (let index = 0; index < newLocationIndexs.length; index++) {
            const element = newLocationIndexs[index];
            if (element.parentKey) {
                let keyArr = element.parentKey.split('-');
                parentKeys = parentKeys.concat(keyArr);
            }
        }
        let expandedRowKeysSet = new Set(parentKeys);
        let list = [...data];
        let treeIndex = 0;
        let currentItem;
        // eslint-disable-next-line no-cond-assign
        while (currentItem = list.shift()) {
            if (newLocationIndexs[currentIndex].key !== currentItem.key) {
                treeIndex++;
            } else {
                break;
            }
            if (Array.isArray(currentItem.children)) {
                // tinper计算currentIndex的逻辑 树表不管你是不是展开，都得放进来算上
                if (expandedRowKeysSet.has(currentItem.key)) {
                    list.unshift(...currentItem.children);
                }

            }
        }
        newLocationIndexs[currentIndex].value = treeIndex;
    }

    // 遍历数据获取定位数组
    getLocationIndex(selectedColumn, data, rowKey, customColData, inputValue, checkValue, deep = 0, parentKeys = 'root', parentIndex = '', treeTableRef) {
        let {
            // 以下是模版字段和筛选条件
            attrcode,
            dataIndex,
            itemtype,
            scale: metaScale,
            languageMeta = [],
            datatype,
            options,
            multiple,
            isconverttimezones,
        } = selectedColumn;
        // 兼容ncTable 数据格式
        attrcode = attrcode || dataIndex;
        // 多语从哪里获取
        let langJson = this.state.json;
        let locationIndexs = [];
        data.forEach((row, index) => {
            const { values, status } = row;
            let rowKeyValue = row[rowKey];
            if (status !== ROW_STATUS.delete) {
                let tableItemValue = '';
                // 自定义列穿进来的数据判断
                if (customColData && customColData[attrcode]) {
                    tableItemValue = customColData[attrcode][rowKeyValue];
                } else {
                    // 不是自定义列的情况
                    // 兼容simpleTable和其他table的数据格式
                    if ((values && values[attrcode]) || row[attrcode]) {
                        // 精度判断数据和模版的情况
                        // tableItemValue = String(values[attrcode].display || values[attrcode].value);
                        tableItemValue = handleBrowse.call(
                            this,
                            itemtype,
                            (values && values[attrcode].display) || (row[attrcode] && row[attrcode].display),
                            (values && values[attrcode].value) || (row[attrcode] && row[attrcode].value) || row[attrcode],
                            metaScale,
                            attrcode,
                            languageMeta,
                            values || row,
                            datatype,
                            options,
                            multiple,
                            langJson,
                            true,
                            isconverttimezones,
                        );
                    }
                }
                isWrong(tableItemValue) && (tableItemValue = '');
                let lowerTableItemValue = String(tableItemValue);
                let lowerFactorValue = String(inputValue);
                // 根据是否区分大小写统一将字符串转为小写
                if (!checkValue) {
                    lowerTableItemValue = String(tableItemValue).toLowerCase();
                    lowerFactorValue = String(inputValue).toLowerCase();
                }
                if (tableItemValue && lowerTableItemValue.includes(lowerFactorValue)) {
                    let locationObj = {
                        level: deep ? 'level-' + deep : '',
                        value: index,
                        key: String(row.key),
                        parentKey: parentKeys,
                        parentIndex: String(parentIndex) ? String(parentIndex) + '-' + index : String(index),
                    }
                    locationIndexs.push(locationObj);
                }
                // 树表的数据递归查找
                if (row.children?.length) {
                    let newParentKey = parentKeys ? (parentKeys + '-' + row.key) : row.key;
                    let newParentIndex = String(parentIndex) ? (String(parentIndex) + '-' + index) : index;
                    let childrenIndexs = this.getLocationIndex(selectedColumn, row.children, rowKey, customColData, inputValue, checkValue, deep + 1, newParentKey, newParentIndex, treeTableRef, index);
                    locationIndexs = locationIndexs.concat(childrenIndexs);
                }
            }
        });
        return locationIndexs;
    }

    /**
     * insertTable 判断是不是在当前定位table内
     */
    filterTableTr = trArr => {
        let result = [];
        for (let index = 0; index < trArr.length; index++) {
            let nearestTable = trArr[index].closest('.nc-table');
            let locationTable = this.props.tableDom.children[0];
            if (nearestTable && nearestTable === locationTable) {
                result.push(trArr[index]);
            }
        }
        return result;
    }

    /**
     * 根据定位筛选的结果操作dom
     */
    getLocationResult = () => {
        let { tableScope, locationCallback } = this.props;
        let { props } = tableScope;
        let { treeTableRef, onExpandedRowsChange } = props;
        let { data, selectedColumn, selectedValue, locationIndexs, currentIndex } = this.state;
        currentIndex > -1 && treeTableRef && this.getTreeTableCurrentIndex(data, locationIndexs, currentIndex);
        if (treeTableRef && locationIndexs.length) {
            // 树表逻辑
            let parentKeys = [];
            for (let index = 0; index < locationIndexs.length; index++) {
                const element = locationIndexs[index];
                if (element.parentKey) {
                    let keyArr = element.parentKey.split('-');
                    parentKeys = parentKeys.concat(keyArr);
                }
            }
            let expandedRowKeys = Array.from(new Set(parentKeys));
            onExpandedRowsChange && onExpandedRowsChange(expandedRowKeys);
        }
        requestAnimationFrame(() => {
            this.props.renderLocationResult(locationIndexs, currentIndex, selectedColumn, selectedValue, treeTableRef, locationCallback);
        });
        // 下一个传next 上一个传pre
        // this.props.renderLocationResult(locationIndexs, currentIndex, selectedColumn, selectedValue, treeTableRef, () => {

        //     requestAnimationFrame(() => {
        //         // 定位结束以后 因为loadBuffer的原因，会出现定位行没有出现在视图内的小问题
        //         // let currentDom = tableDom.querySelector('.column-location-current-tr');
        //         // currentDom && currentDom.scrollIntoView(false)
        //         // currentDom && currentDom.scrollIntoViewIfNeeded()

        //     });
        // });
    }

    // 设置定位td背景色
    setLocationTdBg = (currentTr, currentColIndex, color) => {
        let locationTd = currentTr.querySelectorAll('td')[currentColIndex];
        let locationTableCell = locationTd && locationTd.querySelector('.table-cell-wrapper-bg')
        locationTd && (locationTd.style.background = color);
        locationTableCell && (locationTableCell.style.background = color);
    }

    /**
     * select列字段选择回调
     * @param {*} attr 列的字段
     */
    handleSelectChange = attr => {
        let { columns, inputValue } = this.state;
        let selectedColumn = {};
        columns.map(item => {
            if (item.attrcode === attr || item.dataIndex === attr) {
                selectedColumn = item;
            }
        })
        this.setState({
            selectedValue: attr,
            selectedColumn: selectedColumn,
        })
        this.handleInputChange(inputValue);
    };

    /**
     * input输入条件内容回调
     * @param {*} value 输入的内容
     */
    handleInputChange = value => {
        this.setState({ inputValue: value }, () => {
            if (!value) {
                // 清空input后重新获得焦点
                let input = this.LocationPanelRef.querySelector('input');
                input && input.focus();
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.asyncFlag = true;
            this.timer = setTimeout(() => {
                // 重新给dom增加高亮样式
                this.handleLocation();
            }, 300);

        })
    };

    /**
     * input清空
     */
    clearValue = () => {
        this.handleInputChange("");
    };

    /**
     * checkbox 切换大小写匹配
     * @param {*} value 输入的内容
     */
    handleCheckChange = value => {
        this.setState({ checkValue: value }, () => {
            this.asyncFlag = true;
            // 再去重新给dom增加高亮样式
            this.handleLocation();
        })
    };

    /**
     * 跳转到上一个定位元素
     */
    findThePrevious = () => {
        let { currentIndex } = this.state;
        this.setState({ currentIndex: currentIndex - 1 }, () => {
            this.getLocationResult('pre');
        })
    }

    /**
     * 跳转到下一个定位元素
     */
    findTheNext = () => {
        let { currentIndex, locationIndexs } = this.state;
        // 跳转到最后一个时，下一个被禁用
        // 如果没有定位到数据，下一个也被禁用
        if (currentIndex === locationIndexs.length - 1 || !locationIndexs.length) {
            return;
        }
        this.setState({ currentIndex: currentIndex + 1 }, () => {
            this.getLocationResult();
        });
    }

    /**
     * enter执行筛选的快捷键
     */
    keyDownCallBack = event => {
        if (event && event.keyCode == 13 && this.LocationPanelRef.contains(event.target)) {
            // enter 键
            this.findTheNext();
        } else if (event && event.keyCode == 27) {
            let filterPanel = document.querySelector('.filterPanel-modal.nc-modal');
            if (filterPanel) {
                return;
            }
            // esc 键
            this.cancelLocation();
        }
    };

    /**
     * 模态框点击取消退出本次定位并关闭弹窗
     */
    cancelLocation = () => {
        console.log('关闭');
        // 然后关闭modal
        this.handleHide();
    }
    // 根据当前页面内的定位panel
    getPanelIndex = () => {
        let panelDomList = document.querySelectorAll('.location-panel-modal');
        let length = panelDomList?.length || 0;
        let panelIndex = length + 201;
        return panelIndex;
    }
    onDragStart = () => { }

    onDragStop = () => { };

    render() {
        let panelIndex = this.getPanelIndex();
        let { selectedValue, inputValue, checkValue, locationColumns = [], locationIndexs, currentIndex, json } = this.state;
        return (
            <Dnd
                ref={dom => {
                    this.LocationPanelRef = ReactDOM.findDOMNode(dom);
                }}
                defaultClassName="location-panel-drag"
                handle=".location-panel-header"
                cancel=".cancel-drag"
                onStart={this.onDragStart}
                onStop={this.onDragStop}
                bounds="html"
            >

                <div tabIndex="0" hidefocus="true" className="location-panel-modal" style={{ zIndex: panelIndex }}>
                    {<HotKeys
                        keyMap={{
                            cancelBtnHandler:
                                HotKeys.USUAL_KEYS.MODAL_CALCEL,
                        }}
                        handlers={{
                            cancelBtnHandler: () => {
                                // 取消按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                console.log(
                                    'createModal cancelBtnHandler 事件回调',
                                );
                                this.cancelLocation();
                            },
                        }}
                        className="calculator-hotkeys-wrapper"
                        focused={true}
                        attach={document.body}
                        display="inline"
                    />}
                    <div className="location-panel-header">
                        <button fieldid="close_btn" type="button" className="location-header-close cancel-drag" onClick={this.cancelLocation} aria-label="Close">
                        </button>
                        <img
                            className="location-header-img"
                            src={require('../../../../static/images/modal-img.png')}
                        />
                        <h4 fieldid="ncModal_title" className="location-header-title clearfix">
                            <span>
                                {/* 定位 */}
                                {json['table_location_des']}
                            </span>
                            <span className="location-title-result">
                                {
                                    inputValue
                                        ? (locationIndexs.length
                                            ? <span className="location-title-has-result">
                                                {/* 结果： */}
                                                {json['table_location_result']}
                                                {currentIndex + 1}/{locationIndexs.length}
                                            </span>
                                            : <span className="location-title-no-result">
                                                {/* 结果：找不到匹配项，请检查关键字、字段位置或大小写 */}
                                                {json['table_location_no_result']}
                                            </span>
                                        )
                                        : <span></span>
                                }
                            </span>
                        </h4>
                    </div>
                    <div className="location-panel-body cancel-drag">
                        <div className="location-item-container">
                            <div className="select-container">
                                <Select
                                    showClear={false}
                                    value={selectedValue}
                                    onChange={this.handleSelectChange}
                                >
                                    {/* 请选择 */}
                                    {[...locationColumns].map(
                                        column => {
                                            let { attrcode, dataIndex, label, title } = column;
                                            let option = label || title;
                                            attrcode = attrcode || dataIndex;
                                            if (isFunction(option)) {
                                                console.warn('the column label is Function , maybe error')
                                                option = option({});
                                            }
                                            return <Option key={attrcode} value={attrcode}>{option}</Option>;
                                        },
                                    )}
                                </Select>
                            </div>
                            <div className="input-container">
                                <NCFormControl
                                    value={inputValue}
                                    onChange={this.handleInputChange}
                                    onSelect={e => {
                                        // 在定位弹窗里阻止框选事件冒泡
                                        e.stopPropagation;
                                    }}
                                    autoFocus={true}
                                />
                                {
                                    inputValue ? <div className={`u-form-contorl-suffix has-close`} onClick={this.clearValue}>
                                        {/* <Icon type="uf-close-c" /> */}
                                        <span fieldid="close_btn" type="button" className="location-input-close" onClick={this.clearValue} aria-label="Close"></span>
                                    </div> : ''
                                }
                            </div>
                        </div>
                        <div className="location-item-checkbox">
                            <span className="location-item-checkbox-label">
                                {/* 匹配大小写： */}
                                {json['table_location_check_case']}
                            </span>
                            <Checkbox
                                value={checkValue}
                                onChange={this.handleCheckChange}
                            >
                            </Checkbox>
                        </div>
                    </div>
                    <div className="location-panel-footer">
                        <ButtonGroup>
                            <Button
                                className="filter-btn"
                                fieldid="filter"
                                disabled={!locationIndexs.length || currentIndex < 1}
                                onClick={this.findThePrevious}
                            >
                                {/* 上一个 */}
                                {json['table_location_pre']}
                            </Button>
                            {<Tooltip
                                placement="top"
                                inverse
                                overlay={`${json['table_location_next']}  (Enter)`}
                                trigger={['focus', 'hover']}
                                className="model-helper-overlay"
                            >
                                <Button
                                    className="reset-btn"
                                    fieldid="reset"
                                    colors="primary"
                                    onClick={this.findTheNext}
                                    disabled={!locationIndexs.length || currentIndex > locationIndexs.length - 2}
                                >
                                    {/* 下一个(Enter) */}
                                    {json['table_location_next']}
                                </Button>
                            </Tooltip>}
                        </ButtonGroup>
                        {<Tooltip
                            placement="top"
                            inverse
                            overlay={`${json['table_location_cancel']}  (${HotKeys.USUAL_KEYS.MODAL_CALCEL})`}
                            trigger={['focus', 'hover']}
                            className="model-helper-overlay"
                        >
                            <Button
                                onClick={() => {
                                    this.cancelLocation();
                                }}
                                shape="border"
                                tabIndex="0"
                                fieldid="cancel"
                            >
                                {json['table_location_cancel']}(<span className="text-decoration-underline">N</span>)
                            </Button>
                        </Tooltip>}
                    </div>
                </div>
            </Dnd >

        )
    }
}
export default locationPanel;
